import { render, staticRenderFns } from "./UpdateMasterProfile.vue?vue&type=template&id=6dad863e"
import script from "./UpdateMasterProfile.vue?vue&type=script&lang=js"
export * from "./UpdateMasterProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports